import { Box } from '@material-ui/core';
import dayjs from 'dayjs';
import { useDispatch } from 'dva';
import { useEffect, useState } from 'react';
import TotalCustomer from './components/customer/index';
import KPITrend from './components/kpi_trend/index';
import ProductList from './components/product_list/index';
import { channelMapList } from '@/constants';
import TotalSales from './components/sales/index';
import SearchCondition from './components/search_condition/index';

export default () => {
  const dispatch = useDispatch();
  const [date, setDate] = useState(dayjs().format('YYYY-MM'));
  const [period, setPeriod] = useState('MTD');
  const [channelData, setChannelData] = useState(channelMapList[0]?.id);

  // const searchDate = useSelector((state) => state.bhc.date);

  // 获取totalsales列表statisticalMonth
  const fetchData = () => {
    dispatch({
      type: 'bhc/getTotalSalesV2',
      payload: {
        values: {
          // 年月
          statisticsYear: dayjs(date).format('YYYY'),
          statisticsMonth: dayjs(date).format('YYYY-MM'),
          period: period,
          // channel: channelData,
        },
      },
    });
  };

  useEffect(() => {
    if (date) {
      fetchData();
    }
  }, [date]);

  // 获取totalSales右侧图表
  const fetchReportData = () => {
    dispatch({
      type: 'bhc/getTotalSalesReportV2',
      payload: {
        values: {
          // 年月
          statisticsYear: dayjs(date).format('YYYY'),
          statisticsMonth: dayjs(date).format('YYYY-MM'),
          period: period,
          // channel: channelData,
        },
      },
    });
  };

  useEffect(() => {
    if (date) {
      fetchReportData();
    }
  }, [date]);

  // 获取totalcustomer列表
  const fetchCustomeData = () => {
    dispatch({
      type: 'bhc/getMemberReport',
      payload: {
        values: {
          // 年月
          statisticsYear: dayjs(date).format('YYYY'),
          statisticsMonth: dayjs(date).format('YYYY-MM'),
          period: period,
          // channel: channelData,
        },
      },
    });
  };

  useEffect(() => {
    if (date) {
      fetchCustomeData();
    }
  }, [date]);

  // 查询客单价趋势接口
  const fetchKpiBasketData = () => {
    dispatch({
      type: 'bhc/getKpiList',
      payload: {
        values: {
          // 年月
          statisticsYear: dayjs(date).format('YYYY'),
          statisticsMonth: dayjs(date).format('YYYY-MM'),
          period: period,
          // channel: channelData,
        },
      },
    });
  };

  useEffect(() => {
    if (date) {
      fetchKpiBasketData();
    }
  }, [date]);

  // 当季主推款
  // eslint-disable-next-line no-unused-vars
  const fetchHotProductData = () => {
    dispatch({
      type: 'bhc/getHotProduct',
      payload: {
        values: {
          // 年月
          statisticsYear: dayjs(date).format('YYYY'),
          statisticsMonth: dayjs(date).format('YYYY-MM'),
          period: period,
          // channel: channelData,
        },
      },
    });
  };

  useEffect(() => {
    if (date) {
      fetchHotProductData();
    }
  }, [date]);

  // const getTime = useCallback(() => {
  //   dispatch({
  //     type: 'bhc/getTime',
  //     payload: {},
  //   });
  // }, [dispatch]);

  // useEffect(() => {
  //   getTime();
  // }, [getTime]);

  return (
    <Box
      data-log={JSON.stringify({
        oid: 'page_report_center_brand_health_check_details',
        isPage: true,
        params: {
          initUrl: window.location.origin + window.location.pathname,
        },
        events: ['_pv', '_pd'],
      })}
      id="date_id_mount_parent"
    >
      <Box style={{ margin: '0 12px', paddingTop: '12px' }}>
        <SearchCondition
          period={period}
          setPeriod={setPeriod}
          setChannelData={setChannelData}
          channelData={channelData}
          date={date}
          setDate={setDate}
        ></SearchCondition>
        <TotalSales></TotalSales>
        <TotalCustomer></TotalCustomer>
        <KPITrend></KPITrend>
        <ProductList></ProductList>
      </Box>
    </Box>
  );
};
